import { useEffect, useState } from "react";

const navItems = [
  { label: "热播榜", href: "#ranking" },
  { label: "高分剧单", href: "#rating" },
  { label: "题材选剧", href: "#genres" },
  { label: "追更日历", href: "#schedule" },
  { label: "编辑精选", href: "#editors" },
  { label: "新剧上线", href: "#new" },
  { label: "常见问题", href: "#faq" }
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 border-b border-background-200/70 backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-tv-2-line text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-tight ${
              scrolled || menuOpen ? "text-foreground-950" : "text-background-50"
            }`}
          >
            韩剧TV
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`rounded-md px-3 py-2 font-label text-sm transition-colors ${
                  scrolled || menuOpen
                    ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                    : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅追更提醒
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              scrolled || menuOpen ? "text-foreground-900" : "text-background-50"
            }`}
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 lg:hidden">
          <ul className="grid grid-cols-2 gap-1 px-4 py-3">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="block rounded-md px-3 py-2 font-label text-sm text-foreground-700 hover:bg-background-100"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}